
export class NoteRecord {
  public author?: string | null;
  public dateTimeStamp?: string;
  public note?: string;
 
}
